import { BatchRule } from "../../domain/batch-rule";

export class BatchRuleViewModel extends BatchRule {
  constructor(
    rule: BatchRule,
    public selected: boolean,
  ) {
    super(
      rule.id,
      rule.name,
      rule.format,
      rule.idFormat,
      rule.type,
      rule.dateCreated,
      rule.audioLanguage,
      rule.subtitlesLanguage,
      rule.subtitlesFps,
      rule.subtitlesOffset,
    );
  }

  public clone(): BatchRuleViewModel {
    return new BatchRuleViewModel(this, false);
  }
}
